export const SEO_IMAGE_URL = 'https://minifil.com/og-image.png';
export const SEO_SITE_URL = 'https://minifil.com/';

const APP_ROUTE_PREFIXES = ['/app', '/lists/', '/account-settings', '/account-security', '/admin/'] as const;

export const isLandingRoute = (pathname: string): boolean => pathname === '/';

export const isAppRoute = (pathname: string): boolean =>
    APP_ROUTE_PREFIXES.some((prefix) =>
        prefix.endsWith('/')
            ? pathname.startsWith(prefix)
            : pathname === prefix || pathname.startsWith(`${prefix}/`),
    );

export const setOrCreateMeta = (
    attribute: 'name' | 'property',
    attributeValue: string,
    content: string,
): void => {
    const selector = `meta[${attribute}="${attributeValue}"]`;
    let element = document.querySelector(selector);

    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, attributeValue);
        document.head.appendChild(element);
    }

    element.setAttribute('content', content);
};

export const applyLandingSeo = (title: string, description: string): void => {
    document.title = title;
    setOrCreateMeta('name', 'description', description);
    setOrCreateMeta('property', 'og:site_name', 'Minifil');
    setOrCreateMeta('property', 'og:title', title);
    setOrCreateMeta('property', 'og:description', description);
    setOrCreateMeta('property', 'og:image', SEO_IMAGE_URL);
    setOrCreateMeta('property', 'og:url', SEO_SITE_URL);
    setOrCreateMeta('name', 'twitter:card', 'summary_large_image');
    setOrCreateMeta('name', 'twitter:title', title);
    setOrCreateMeta('name', 'twitter:description', description);
    setOrCreateMeta('name', 'twitter:image', SEO_IMAGE_URL);
};

export const applyAppPageTitle = (title: string): void => {
    document.title = title;
};
